<template>
  <app-layout id="main_dashboard">
    <template #header>
      <AppHead title="Dashboard" />

      <div v-if="this.$page.props.auth.user.mtd_enabled_tu_features">
        <div v-if="linked.length > 0">

            <Multiselect
              v-model="linked_id"
              :options="linked_select" 
              :searchable="true"
              placeholder="Select Account"
              id="location_select" 
              @change="selectAccount" 
              @clear="clearAccount"
            />
        </div>

        <LocationTabs
          @daySelected="daySelected" 
          @selectAll="selectAllLocations"
          @saveDay="saveSelectedDay"
          @selectUnassigned="selectUnassignedLocations" 
        />

        <div class="row pb-1">
          <div class="col-md-4 mb-2 mb-md-0 location-inputs">
            <Multiselect
              v-model="location_id"
              :options="locations_select" 
              :searchable="true"
              placeholder="Select Location"
              id="location_select" 
              @change="selectLocation" 
              @clear="clearLocation"
            />

            <EditLocation :location="location" :states="states" />
          </div>

          <div class="col-md-4 mb-2 mb-md-0">
            <Multiselect
              v-model="user_id"
              :options="users"
              :searchable="true"
              placeholder="User Search"
              id="user_select"
              @change="selectUser"
              @clear="clearUser"
            />
          </div>

          <OptionsDropdown :states="states" :location="location" :account_balance="user['account_balance']" @saveLocation="saveLocation" @beforeSaveLocation="beforeSaveLocation" />
        </div>
      </div>
        
      <flash-messages />
    </template>

    <div class="py-2">
      <LocationsList 
        :locations="filteredLocations" 
        :loading="locationsLoading" 
        :selected="locationSelected"
        :users="users"
        :show="Object.keys(selectedUser).length || location_id ? false : true"
        @rowClicked="setLocationId"
      />
      <UsersList
        :users="users" 
        :location="location"
        :loading="usersLoading"
        :location_id="location_id"
        :user="selectedUser"
        @clearLocation="clearLocation"
      />

      <section v-if="orders.length">
        <h3>New Orders</h3>

        <DataTable :value="orders" 
        :rowClass="() => { return 'table-row' }"
        breakpoint="992px"
        responsiveLayout="stack"
        stripedRows
        id="dashboardTable"
        class="p-datatable-sm"
        tableClass="border-left border-right border-bottom"
        @row-click="e => showOrderDetail(e.data)"> 
          <Column class="id pl-3" field="id" header="ID" headerClass="pl-3" >
            <template #body="slotProps">
              #{{slotProps.data.id}}
              <PaymentType class="ml-2" :payment="slotProps.data.payment" />
            </template>
          </Column>
          <Column field="status_desc" header="Status"></Column>
          <Column field="customer_name" header="Customer"></Column>
          <Column class="total" field="total" header="Total">
            <template #body="slotProps">
              {{ formatDollars(slotProps.data.total) }}
            </template>
          </Column>
          <Column field="date" header="Date">
            <template #body="slotProps">
              {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
            </template>
          </Column>
        </DataTable>

        <div class="mt-2">
          <inertia-link class="flex items-center" :href="route('mtd.orders.list')" tabindex="-1">
            <i class="fas fa-angle-right"></i> View All
          </inertia-link>
        </div>
      </section>
    </div>

  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import Icon from '@/Shared/Icon'
import moment from 'moment'
import Multiselect from '@vueform/multiselect'
import ScrollSticky from '@/Shared/ScrollSticky'

import LocationTabs from '@/Components/Dashboard/LocationTabs'
import LocationsList from '@/Components/Dashboard/LocationsList'
import UsersList from '@/Components/Dashboard/UsersList'
import OptionsDropdown from '@/Components/Dashboard/OptionsDropdown'
import EditLocation from '@/Components/Dashboard/EditLocation.vue'
import PaymentType from '@/Components/Transaction/PaymentType'

export default {
  components: {
    AppLayout,
    FlashMessages,
    JetInput,
    JetCheckbox,
    JetInputError,
    JetLabel,
    Icon,
    LocationTabs,
    Multiselect,
    LocationsList,
    UsersList,
    OptionsDropdown,
    EditLocation,
    ScrollSticky,
    PaymentType
  },
  props: {
    orders: Array,
    user: Object,
    locations: Array,
    locations_select: Array,
    location: Object,
    users: Array,
    tu: Object,
    notes: Array,
    states: Array,
    linked: Array,
  },
  data() {
    let linked_select = this.linked.map((account) => {
      return {
        value: account.id,
        label: account.company_name + " " + account.first_name + " " + account.last_name
        }
      });

    return {
      currentDate: moment(),
      locationsLoading: false,
      selectedUser: {},
      usersLoading: false,
      location_id: this.location ? this.location.id : null,
      user_id: this.tu ? this.tu.id : null,
      locationSelected: '',
      order: { 
        user: {},
        shipments:[],
        payments:[],
        items:[],
        note:[]
      },
      shipments: [],
      items: [],
      formNote: this.$inertia.form({
        _method: 'put',
        content: null
      }),
      filteredLocations: this.locations,
      linked_id: this.$page.props.auth.user.id,
      linked_select: linked_select,
    }
  },
  created() {
    this.moment = moment
  },
  mounted() {
    if (this.user_id) this.selectUser(this.user_id)

    if (this.$page.props.auth.user.mtd_enabled_tu_features && (
      this.$page.props.auth.user.mtd_tax_upload_done == 0 ||
      this.$page.props.auth.user.mtd_payout_done == 0 ||
      this.$page.props.auth.user.mtd_product_done == 0 ||
      this.$page.props.auth.user.mtd_user_done == 0)) {
        $('#mtdSteps').modal('show');
    }
  },
  unmounted() {
    $('#mtdSteps').modal('hide');
  },
  methods: {
    daySelected(day) {
      this.$inertia.visit(this.route('dashboard.resetlocation'), {
        preserveState: true,
        onSuccess: () => {
          this.locationSelected = day.name
          this.user_id = 0
          this.location_id = 0
          this.saveSelectedDay(day)
        }
      })
    },
    saveSelectedDay(day) {
      axios.get(this.route('dashboard.day', day.dayIndex)).then(res => {
        this.filteredLocations = this.locations.filter(elem => elem.location_visit_on_day === day.dayIndex)        
        this.locationsLoading = false
      })
    },
    selectUser(user_id) {
      if (!user_id) return

      for (let e=0; e<this.users.length; e++) {
        if (this.users[e].value === user_id) {
          if (this.users[e].location_id) this.location_id=this.users[e].location_id
          this.selectedUser = this.users[e]
        }
      }
      axios.get(route('dashboard.user', user_id))
      },
      clearUser() {
        this.selectedUser = false
        this.selectLocation(this.location_id)
      },
      selectAllLocations(clear=false) {
        axios.get(this.route('dashboard.day', -1)).then(res => {
          if (clear) this.clearLocation()
          this.locationsLoading = false
          this.locationSelected = 'all'
          this.filteredLocations = this.locations
        })
      },
      clearLocation() {
        this.$inertia.visit(this.route('dashboard.resetlocation'))
      },
      selectUnassignedLocations(clear=false) {
        axios.get(this.route('dashboard.day', -2)).then(res => {
          if (clear) this.clearLocation()
          this.locationSelected = 'unassigned'
          this.filteredLocations = this.locations.filter(elem => elem.location_visit_on_day === null)
        })
      },
      showOrderDetail(order){
        this.$inertia.visit(this.route('mtd.order.view', order));
      },
      selectLocation(id) {
        this.usersLoading = true
        if (id) this.$inertia.visit(this.route('dashboard.location', id), {
          onSuccess: () => { this.usersLoading = false }
        })
      },
      setLocationId(id) {
        this.location_id = id
        this.selectLocation(id)
      },
      beforeSaveLocation() {
        this.user_id = ''
      },
      saveLocation(form) {
        const newLocation = this.locations.filter(elem => { 
          return elem.label === (form.company_name + ' ' + form.address1).replace(/\s\s+/g, ' ')
        })

        if (newLocation.length) {
          this.setLocationId(newLocation[0].id)
          this.selectLocation(newLocation[0].id)
        }
      },
      selectAccount(id) {
        if (!id) return; 

        this.$inertia.visit(this.route('mtd.useaslinked', id), {
          onSuccess: () => { this.usersLoading = false }
        })
      },
      clearAccount() {
        this.$inertia.visit(this.route('mtd.enduseaslinked', this.$page.props.auth.user.id), {
                  onSuccess: () => { this.usersLoading = false }
                })
      }
    }
  }
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
